import moment from 'moment'
import Vue from 'vue'
import VueI18n from 'vue-i18n'


export const formatAge = (value: Date|string) => {
  if (value) {      
    moment.locale("fr")     
    const duree = moment.duration(new Date().getTime() - new Date(value).getTime())
    return duree.asYears()>1?`${duree.years()} ans`:duree.asYears()>0?`${duree.years()} an`:`${duree.months()} mois`
  }
}
Vue.filter('formatAge',formatAge)
